import React from "react";

export default function SkillsPage() {
  return <h2>SkillsPage</h2>;
}
